<form>
  <div class="row form-row">
    <mat-form-field
      [ngClass]="isMobileView ? 'filter-field-mobile' : 'filter-field'"
      appearance="outline"
    >
      <mat-label>{{ translationService.getFiltersText() }}</mat-label>
      <mat-select [(value)]="selectedFilters" multiple>
        @for (filter of filters; track filter) {
          <mat-option [value]="filter">{{ filter.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div [ngClass]="!isMobileView ? 'grid-container' : ''">
    @for (filter of selectedFilters; track filter) {
      @if (getFilterValueProp(filter.label)) {
        <mat-form-field
          [ngClass]="isMobileView ? 'filter-option-mobile' : 'filter-option'"
          appearance="outline"
        >
          <mat-label>{{ filter.label }}</mat-label>
          <input
            matInput
            [(ngModel)]="filterValues[getFilterValueProp(filter.label)!]"
            type="text"
            [name]="getFilterValueProp(filter.label)!"
            #filterInput="ngModel"
            [minlength]="2"
            [ngModel]="filterValues[getFilterValueProp(filter.label)!]"
          />
        </mat-form-field>
      }
    }
  </div>
  <div [ngClass]="!isMobileView ? 'row form-row align-right' : ''">
    <button
      mat-button
      [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
      type="button"
      (click)="resetFilter()"
    >
      <mat-icon>refresh</mat-icon>
      {{ translationService.getResetFilterText() }}
    </button>
    <button
      mat-flat-button
      color="primary"
      [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
      type="button"
      (click)="filterChange()"
      [disabled]="!isFormValid()"
    >
      <mat-icon>search</mat-icon>
      {{ translationService.getFilterResultsText() }}
    </button>
  </div>
</form>
